// extracted by mini-css-extract-plugin
export default {"main-container":"JoinedLists_main-container__kASiO"};